import React, { useState } from 'react'
import {
    Button,
    Collapse,
    Col,
    Row,
    Dropdown,
    Modal,
    Card,
    Tooltip,
} from 'antd'
import {
    EditOutlined,
    EyeOutlined,
    DownOutlined,
    DeleteOutlined,
} from '@ant-design/icons'
import commonStyles from '../../../../../../Utils/Common.less'
import FullWidthModal from '../../../../../../Components/FullWidthModal'
import { connect, useDispatch } from 'react-redux'
import {
    AttachIndividual,
    GenerateAccount,
} from '../../../../../../Services/Corporate'
import OfficerPersonModelForm from '../../../Corporate/Buttons/OfficerButton/OfficerPersonModelForm'
import Partners from './partners'
import PartnerViewPage from './patnerviewPage'
import PartnerMemberEditForm from './partnerEditPage'
import {
    type PartnerTapData,
    type PartnersDataInterface,
} from '../../../../../../Types/Client/RegisteredClients/Partnership'
import {
    DeletePartner,
    getClientCompanyDetails,
} from '../../../../../../Services/Parnership'
const { Panel } = Collapse
type EditStates = Record<number, boolean>
const defaultPartnerData = {
    partnerId: 0,
    partnershipId: 0,
    individualId: 0,
    tagIndividualId: 0,
    individualClientNumber: '',
    title: '',
    firstName: '',
    middleName: '',
    surName: '',
    dateOfBirth: '',
    partnerAddressOne: '',
    partnerAddressTwo: '',
    partnerTown: '',
    partnerCountry: '',
    partnerPostCode: '',
    mobileNumber: '',
    homeNumber: '',
    workNumber: '',
    emailAddress: '',
    alternativeEmailAddress: '',
    individualUTR: '',
    niNumber: '',
    isActive: '',
    isDelete: '',
}
const PartnerMainPage = (props: {
    partnershipId: number
    partnershipTaps: PartnerTapData[]
    activeTab: string
}): React.ReactElement => {
    const { partnershipId, partnershipTaps, activeTab } = props
    const dispatch = useDispatch()
    const [isEditMode, setIsEditMode] = useState<EditStates>({})
    const [generateAccountModalVisible, setGenerateAccountModalVisible] =
        useState(false)
    const [deleteAccountModalVisible, setDeleteAccountModalVisible] =
        useState(false)
    const [tagModalVisible, setTagModalVisible] = useState(false)
    const [memeberreferenceId, setMemberRefernce] = useState<number>(0)
    const [referenceId, setRefernceid] = useState<number>(0)
    const [editData, setEditData] = useState<PartnerTapData>(defaultPartnerData)
    const [removeAccounModel, setRemoveAccountModel] = useState(false)
    const [activeKey, setActiveKey] = useState<string | string[]>([])
    const [activeKey2, setActiveKey2] = useState<string[]>(['1'])
    const [resetData, setResetData] = useState('false')
    const [tagVisible, setTagvisible] = useState('')
    const [tagIndividualId, settagIndividualId] = useState(0)
    const handleEditClick = (referenceId: number): void => {
        setIsEditMode((prevEditStates) => ({
            ...prevEditStates,
            [referenceId]: !prevEditStates[referenceId],
        }))
        const datas = partnershipTaps?.find((data: PartnerTapData) => {
            return data?.partnerId === referenceId
        })
        setEditData(datas ?? defaultPartnerData)
    }

    const openTagModal = (): void => {
        setTagModalVisible(true)
        setGenerateAccountModalVisible(false)
    }

    const handleCancel = (): void => {
        setTagModalVisible(false)
        ReFetchData()
    }

    // useEffect(() => {
    //     const memberDetailss =
    //         SelectName !== null && SelectName !== 0
    //             ? partnershipTaps?.find(
    //                   (member: { partnerId: number }) =>
    //                       member.partnerId === SelectName
    //               )
    //             : null

    //     setTagName(memberDetailss?.individualId.toString() ?? '')
    // }, [SelectName])
    const opendleteModel = (referenceId: number): void => {
        setRefernceid(referenceId)
        setDeleteAccountModalVisible(true)
    }
    const items =
        tagVisible === ''
            ? [
                  {
                      key: '1',
                      label: 'Attach Tag',
                      onClick: openTagModal,
                  },
                  {
                      key: '2',
                      label: 'Generate Account',
                      onClick: () => {
                          setGenerateAccountModalVisible(true)
                      },
                  },
              ]
            : [
                  {
                      key: '3',
                      label: 'Remove Tag',
                      onClick: () => {
                          setRemoveAccountModel(true)
                      },
                  },
              ]

    const hadelClickGenerateAccounts = (
        referenceId: number,
        tagIndividualId: number
    ): void => {
        setMemberRefernce(referenceId)
        settagIndividualId(tagIndividualId)
    }

    const GenerateAccounts = async (getreferenceid: number): Promise<void> => {
        if (getreferenceid !== null) {
            await GenerateAccount(dispatch, 4, getreferenceid).then(
                (result) => {
                    if (result !== null && result !== undefined) {
                        setGenerateAccountModalVisible(false)
                        ReFetchData()
                    }
                }
            )
        }
    }

    const handeldeleteShareholder = (partnerId: number): void => {
        void DeletePartner(dispatch, partnershipId, partnerId, ReFetchData)

        setDeleteAccountModalVisible(false)
    }
    const tabIndex = 8
    const businessTypeId = 4
    const ReFetchData = (): void => {
        void getClientCompanyDetails(
            dispatch,
            businessTypeId,
            partnershipId,
            tabIndex
        )
    }

    const handleSaveCallBack = (data: PartnerTapData): void => {
        setIsEditMode((prevEditStates) => ({
            ...prevEditStates,
            [data?.partnerId ?? 0]: false,
        }))
    }

    const RemoveTagAccount = async (getreferenceid: number): Promise<void> => {
        await AttachIndividual(
            dispatch,
            tagIndividualId,
            4,
            getreferenceid,
            1
        ).then((result) => {
            if (result !== null && result !== undefined) {
                setRemoveAccountModel(false)
                ReFetchData()
            }
        })
    }
    const handleSave = (): void => {
        setActiveKey2([])
    }

    return (
        <Card title="Partner Information">
            {Array.isArray(partnershipTaps) &&
                partnershipTaps?.map((partner, index) => (
                    <Collapse
                        defaultActiveKey={['']}
                        activeKey={activeKey}
                        className={commonStyles.corporateOfficercollaps}
                        key={index + 1}
                        onChange={(key) => {
                            setActiveKey(key)
                        }}
                    >
                        <Panel
                            header={
                                <div
                                    style={{
                                        display: 'flex',
                                        justifyContent: 'space-between',
                                    }}
                                >
                                    <span>
                                        {`${partner?.title} ${partner?.firstName} ${partner?.middleName} ${partner?.surName}`}
                                    </span>
                                </div>
                            }
                            key={index + 1}
                        >
                            <Row gutter={16} justify="end">
                                <Col>
                                    <Dropdown
                                        menu={{ items }}
                                        placement="bottom"
                                        arrow={{ pointAtCenter: true }}
                                        trigger={['click']}
                                        onOpenChange={() => {
                                            setTagvisible(
                                                partner.individualClientNumber
                                            )
                                        }}
                                    >
                                        {partner.individualClientNumber !==
                                            null &&
                                        partner?.individualClientNumber !==
                                            '' ? (
                                            <Button
                                                type="primary"
                                                onClick={(): void => {
                                                    hadelClickGenerateAccounts(
                                                        partner?.partnerId,
                                                        partner?.tagIndividualId
                                                    )
                                                }}
                                            >
                                                {
                                                    partner?.individualClientNumber
                                                }
                                                <DownOutlined />
                                            </Button>
                                        ) : (
                                            <Button
                                                type="primary"
                                                onClick={(): void => {
                                                    hadelClickGenerateAccounts(
                                                        partner?.partnerId,
                                                        partner?.tagIndividualId
                                                    )
                                                }}
                                            >
                                                Tag
                                                <DownOutlined />
                                            </Button>
                                        )}
                                    </Dropdown>
                                </Col>

                                <Col>
                                    <Tooltip title=" Delete Partner">
                                        <Button
                                            type="primary"
                                            onClick={(): void => {
                                                opendleteModel(
                                                    partner?.partnerId
                                                )
                                            }}
                                        >
                                            <DeleteOutlined />
                                        </Button>
                                    </Tooltip>
                                </Col>

                                <Col>
                                    <Tooltip
                                        title={`${isEditMode[partner?.partnerId] ? 'View Details' : 'Edit Details'}`}
                                    >
                                        <Button
                                            type="primary"
                                            onClick={(): void => {
                                                handleEditClick(
                                                    partner?.partnerId
                                                )
                                            }}
                                        >
                                            {isEditMode[partner?.partnerId] ? (
                                                <EyeOutlined />
                                            ) : (
                                                <EditOutlined />
                                            )}
                                        </Button>
                                    </Tooltip>
                                </Col>
                            </Row>
                            {isEditMode[partner?.partnerId] ? (
                                <PartnerMemberEditForm
                                    editData={editData}
                                    corporateId={partner?.partnerId}
                                    saveCallBack={(data: PartnerTapData) => {
                                        handleSaveCallBack(data)
                                    }}
                                    ReFetchData={ReFetchData}
                                    activeTab={activeTab}
                                />
                            ) : (
                                <PartnerViewPage partnershipTaps={partner} />
                            )}
                        </Panel>
                    </Collapse>
                ))}
            <Collapse
                activeKey={activeKey2}
                onChange={(keys) => {
                    setResetData('true')
                    setActiveKey2(keys)
                }}
            >
                <Panel header="Add Partner" key="1">
                    <Partners
                        partnershipId={partnershipId}
                        setResetData={setResetData}
                        resetdata={resetData}
                        handleSave={handleSave}
                        activeTab={activeTab}
                    />
                </Panel>
            </Collapse>
            <FullWidthModal
                modalStatus={generateAccountModalVisible}
                closeModal={() => {
                    setGenerateAccountModalVisible(false)
                }}
                tittle="You are about to generate the individual account. Click 'Yes' to continue."
                smallTittle="Warning: This action cannot be undone!"
                yesButtonFunction={() => {
                    void GenerateAccounts(memeberreferenceId)
                }}
            />
            <FullWidthModal
                modalStatus={deleteAccountModalVisible}
                closeModal={() => {
                    setDeleteAccountModalVisible(false)
                }}
                tittle="You are about to delete this partner. Click 'Yes' to continue."
                smallTittle="Warning: This action cannot be undone!"
                yesButtonFunction={() => {
                    handeldeleteShareholder(referenceId)
                }}
            />
            <Modal
                title="Please select the Individual Account"
                onCancel={() => {
                    setTagModalVisible(false)
                }}
                open={tagModalVisible}
                footer={null}
                width={'40%'}
            >
                <OfficerPersonModelForm
                    onCancel={handleCancel}
                    referencId={partnershipId}
                    companyType={4}
                />
            </Modal>
            <FullWidthModal
                modalStatus={removeAccounModel}
                closeModal={() => {
                    setRemoveAccountModel(false)
                }}
                tittle="You are about to remove this business tag. Click 'Yes' to continue."
                smallTittle="Warning: This action cannot be undone!"
                yesButtonFunction={() => {
                    void RemoveTagAccount(memeberreferenceId)
                }}
            />
        </Card>
    )
}
const mapStateToProps = (state: any): PartnersDataInterface => {
    return {
        countryList: state.common.countryList,
        partnershipTaps: state.client.partnershipTaps,
        InduvidualMemberList: state.common.InduvidualMemberList,
    }
}
export default connect(mapStateToProps)(PartnerMainPage)
